export default {
      id: "Icon--arrowUp-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--arrowUp",
      toString: function () {
        return this.url;
      }
    }